module.exports = __webpack_public_path__ + "static/img/freight.d6f51a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/freight.png
// module id = 2RDx
// module chunks = 1